<template>
  <div class="max-w-2xl mx-auto">
    <h2 class="text-lg font-bold mb-6">
      {{ operation ? __('Edit operation') : __('Add operation') }}
    </h2>

    <form @submit.prevent="save">
      <div>
        <label class="block text-sm font-semibold text-gray-700 mb-2">
          {{ __("Name") }}
        </label>
        <text-input v-model="form.name" :data-error="form.errors.name" autocomplete="off"/>
        <div v-if="form.errors.name" class="text-red-500 text-sm mt-1">
          {{ form.errors.name }}
        </div>
      </div>

      <div class="mt-6 flex items-center justify-between">
        <inertia-link :href="route('settings.operations')" class="text-gray-500 hover:text-gray-700">
          {{ __("Cancel") }}
        </inertia-link>
        <loading-button type="submit" :loading="form.processing" class="btn-primary">
          {{ __("Save") }}
        </loading-button>
      </div>
    </form>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import SettingsLayout from '@/Shared/SettingsLayout';
import TextInput from '@/Shared/TextInput';
import LoadingButton from '@/Shared/LoadingButton';

export default {
  layout: (h, page) => h(Layout, [h(SettingsLayout, [page])]),
  metaInfo() {
    return {
      title: this.operation ? this.__('Edit operation') : this.__('Add operation'),
    };
  },
  props: {
    operation: Object,
  },
  components: { TextInput, LoadingButton },
  data() {
    return {
      form: this.$inertia.form({
        name: this.operation?.name || '',
      }),
    };
  },
  methods: {
    save() {
      if (this.operation) {
        this.form.put(this.route('settings.operations.update', { operationCatalog: this.operation.id }));
      } else {
        this.form.post(this.route('settings.operations.store'));
      }
    },
  },
};
</script>
